import { useEffect, useState } from 'react';
import { ArrowRight, Globe } from 'lucide-react';
import { AKILLICOZUM_URL } from '../lib/subdomain';

const SECONDS = 10;

export const DomainMovedNotice = () => {
  const target = `${AKILLICOZUM_URL}${window.location.pathname}${window.location.search}${window.location.hash}`;
  const [left, setLeft] = useState(SECONDS);

  useEffect(() => {
    if (left <= 0) {
      window.location.replace(target);
      return undefined;
    }
    const t = setTimeout(() => setLeft(left - 1), 1000);
    return () => clearTimeout(t);
  }, [left, target]);

  return (
    <div data-testid="domain-moved-notice" className="min-h-screen flex items-center justify-center bg-emerald-50 px-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
      <div className="max-w-lg w-full bg-white rounded-2xl shadow-xl border border-emerald-100 p-8 text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-emerald-600 flex items-center justify-center mb-6">
          <Globe className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">AkıllıÇözüm yeni adresine taşındı</h1>
        <p className="text-slate-600 mb-2">
          <span className="font-medium">hesap.weddingtakip.com</span> artık{' '}
          <span className="font-semibold text-emerald-700">www.akillicozum.com.tr</span> adresine geçiş yapıyor.
        </p>
        <p className="text-slate-600 mb-6">
          <span data-testid="domain-moved-countdown" className="font-bold text-emerald-700 text-lg">{Math.max(left, 0)}</span> saniye sonra otomatik olarak yönlendirileceksiniz.
        </p>
        <a
          data-testid="domain-moved-link"
          href={target}
          className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-6 py-3 rounded-full transition-colors"
        >
          Yönlendirme çalışmazsa tıklayınız <ArrowRight className="w-4 h-4" />
        </a>
        <p className="text-xs text-slate-400 mt-6">Verileriniz korunmaktadır. Yeni adreste aynı e-posta ve şifrenizle giriş yapabilirsiniz.</p>
      </div>
    </div>
  );
};
